import { render, staticRenderFns } from "./adminApply.vue?vue&type=template&id=1c37af20&scoped=true"
import script from "./adminApply.vue?vue&type=script&lang=js"
export * from "./adminApply.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/admin/adminApply.css?vue&type=style&index=0&id=1c37af20&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37af20",
  null
  
)

export default component.exports